import { Input, Modal } from 'antd';

import { CustomInputNumber } from '@app/components';
import { CANCEL, SAVE } from '@app/constants';
import type { EditCellModalProps } from '@app/pages/Analytics/SalaryReport/types';

export const EditCellModal: React.FC<EditCellModalProps> = ({
  editCellModalOpen,
  closeEditCellModal,
  editableField,
  editableValue,
  handleEditableValueChange,
  setEditableValue,
  handleSaveEditCellModal,
  isLoading,
}) => {
  return (
    <Modal
      destroyOnHidden={false}
      open={editCellModalOpen}
      onCancel={closeEditCellModal}
      onOk={handleSaveEditCellModal}
      okText={SAVE}
      cancelText={CANCEL}
      title="Введите значение"
      okButtonProps={{
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      {editableField === 'Comment' ? (
        <Input
          value={editableValue || ''}
          onChange={handleEditableValueChange}
        />
      ) : (
        <CustomInputNumber
          className="required-field"
          isAllowed={(floatValue: number) => floatValue >= 0.01}
          onSuccess={({ value }) => {
            setEditableValue(value);
          }}
          inputValue={editableValue}
        />
      )}
    </Modal>
  );
};
